import React from 'react';
import { Image } from 'react-native';
import { PermissionsAndroid, Platform } from 'react-native';
// import { launchCamera, launchImageLibrary } from 'react-native-image-picker';
import { launchCamera, launchImageLibrary } from '../../../Components/RNImagePicker';
import { SHr, SNotification, SPopup, SText, STheme, SView } from 'servisofts-component2';
import Plus_insert_foto from '../../../Assets/plus_insert_foto.svg';
import Camera_icon from '../../../Assets/camera_icon.svg';

export default function Item_photo_picker({ label, text, uri, onChange, required, highlightRequired, disabled, uploadStatus = 'idle', uploadMessage, uploadRetryLabel = 'Reintentar', onRetryUpload, labelWidth = 120, boxWidth = 130, boxHeight = 130 }) {
    const [showPicker, setShowPicker] = React.useState(false);
    const webFileInputRef = React.useRef(null);
    const hasUploadError = uploadStatus === 'error';
    const isUploading = uploadStatus === 'uploading';

    const emitFile = (asset, fallbackName = 'foto.jpg') => {
        const nextFile = asset?.uri ? {
            uri: asset.uri,
            name: asset?.fileName || fallbackName,
            type: asset?.type || 'image/jpeg',
            size: asset?.fileSize,
            file: asset?.file,
        } : null;
        if (nextFile) onChange?.(nextFile);
    };

    const handleResult = (response) => {
        if (response?.didCancel) return;
        if (response?.errorCode) {
            SNotification.send({
                key: 'checklist_pick_photo_error',
                title: 'No se pudo obtener la foto',
                body: String(response?.errorMessage || response?.errorCode || 'Intenta nuevamente.'),
                color: STheme.color.danger,
                time: 3000,
            });
            return;
        }
        const asset = response?.assets?.[0];
        if (!asset?.uri) {
            SNotification.send({
                key: 'checklist_pick_photo_empty',
                title: 'Foto no valida',
                body: 'No se pudo obtener una imagen valida.',
                color: STheme.color.danger,
                time: 3000,
            });
            return;
        }
        SPopup.close("checklist_photo_picker");
        emitFile(asset, asset?.fileName || 'foto.jpg');
    };

    const requestCameraPermission = async () => {
        if (Platform.OS !== 'android') return true;
        try {
            const granted = await PermissionsAndroid.request(
                PermissionsAndroid.PERMISSIONS.CAMERA,
                {
                    title: 'Permiso de camara',
                    message: 'Necesitamos acceso a la camara para tomar la foto del checklist.',
                    buttonPositive: 'Aceptar',
                    buttonNegative: 'Cancelar',
                }
            );
            return granted === PermissionsAndroid.RESULTS.GRANTED;
        } catch {
            return false;
        }
    };

    const pickFromCamera = async () => {
        const hasPermission = await requestCameraPermission();
        if (!hasPermission) {
            SNotification.send({
                key: 'checklist_camera_permission_denied',
                title: 'Permiso de camara requerido',
                body: 'Debes habilitar el permiso para tomar una foto.',
                color: STheme.color.danger,
                time: 3000,
            });
            return;
        }
        launchCamera({ mediaType: 'photo', quality: 0.8, includeBase64: false, saveToPhotos: true }, handleResult);
    };

    const pickFromGallery = () => {
        launchImageLibrary({ mediaType: 'photo', quality: 0.8, includeBase64: false }, handleResult);
    };

    const handlePress = () => {
        if (disabled) return;
        if (Platform.OS === 'web') {
            webFileInputRef.current?.click?.();
            return;
        }
        // setShowPicker(true);
        SPopup.open({
            key: "checklist_photo_picker",
            content: (
                <SView col="xs-12" style={{ backgroundColor: '#0C2340', borderTopLeftRadius: 18, borderTopRightRadius: 18, borderRadius: 8, padding: 16, paddingBottom: 24 }}>
                    <SView col="xs-12" center>
                        <SView width={42} height={5} style={{ borderRadius: 8, backgroundColor: '#B7C7D966' }} />
                    </SView>
                    <SHr height={10} />
                    <SText font='AlbertSans' bold center fontSize={18} color={STheme.color.secondary}>Enviar foto</SText>
                    <SHr height={12} />
                    <SView col="xs-12" height={52} center onPress={pickFromCamera} style={{ borderRadius: 12, backgroundColor: STheme.color.secondary }}>
                        <SText font='AlbertSans' bold color={'#0C2340'} fontSize={17}>Tomar foto</SText>
                    </SView>
                    <SHr height={10} />
                    <SView col="xs-12" height={52} center onPress={pickFromGallery} style={{ borderRadius: 12, backgroundColor: '#14365F', borderWidth: 1, borderColor: STheme.color.secondary + '66' }}>
                        <SText font='AlbertSans' color={'#EAF2FF'} fontSize={16}>Subir de galería</SText>
                    </SView>
                    <SHr height={10} />
                    <SView col="xs-12" height={46} center onPress={() => {
                        SPopup.close("checklist_photo_picker");
                    }} style={{ borderRadius: 10, borderWidth: 1, borderColor: '#B7C7D988' }}>
                        <SText font='AlbertSans' color={'#D8E0EA'} fontSize={15}>Cancelar</SText>
                    </SView>
                </SView>
            ),
            // onClose: () => setShowPicker(false),
        });
    };

    const handleRemovePhoto = () => {
        if (disabled) return;
        SPopup.close("checklist_photo_picker");
        onChange?.(null);
        if (Platform.OS === 'web' && webFileInputRef.current) {
            webFileInputRef.current.value = '';
        }
    };

    const handleWebFileChange = (event) => {
        const selectedFile = event?.target?.files?.[0];
        if (!selectedFile) return;
        onChange?.({
            uri: URL.createObjectURL(selectedFile),
            name: selectedFile.name,
            type: selectedFile.type || 'image/jpeg',
            size: selectedFile.size,
            file: selectedFile,
        });
        event.target.value = '';
    };

    return (
        <>
            <SView width={labelWidth} center style={{}}>
                <SText font='AlbertSans' bold color={STheme.color.secondary} fontSize={10} center>
                    {label}{required ? ' *' : ''}
                </SText>
                <SHr height={8} />
                <SView width={boxWidth} height={boxHeight} center style={{ borderRadius: 8, backgroundColor: STheme.color.lightGray, overflow: 'hidden', borderWidth: highlightRequired || hasUploadError ? 2 : 0, borderColor: highlightRequired ? STheme.color.danger : hasUploadError ? '#E5484D' : 'transparent', }}
                    onPress={handlePress} >
                    {uri ? (<>
                        <Image source={{ uri }} style={{ width: "100%", height: "100%", borderRadius: 4 }} resizeMode="cover" />
                        <SView width={35} height={35} center style={{ position: "absolute", top: 4, right: 4, backgroundColor: STheme.color.secondary, borderColor: STheme.color.background, borderWidth: 2, borderRadius: 40, }} >
                            <Camera_icon width={19} height={16} />
                        </SView>
                        {/* <SView
                            width={28}
                            height={28}
                            center
                            onPress={handleRemovePhoto}
                            style={{ position: 'absolute', top: 8, left: 8, backgroundColor: '#B42318', borderRadius: 20, borderWidth: 1, borderColor: '#FFFFFF55', zIndex: 3 }}
                        >
                            <SText font='AlbertSans' bold color={'#FFFFFF'} fontSize={16}>×</SText>
                        </SView> */}
                        {hasUploadError || isUploading ? (
                            <SView
                                style={{
                                    position: 'absolute',
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: hasUploadError ? '#B42318EE' : 'rgba(12, 35, 64, 0.85)',
                                    paddingHorizontal: 8,
                                    paddingVertical: 6,
                                    zIndex: 2,
                                }}
                                onPress={hasUploadError ? handlePress : undefined}
                            >
                                <SText font='AlbertSans' bold center color={'#FFFFFF'} fontSize={10}>
                                    {hasUploadError ? (uploadMessage || 'No se subió') : 'Subiendo...'}
                                </SText>
                                {hasUploadError ? (
                                    <SView row style={{ gap: 8, marginTop: 4, justifyContent: 'center' }}>
                                        <SView
                                            height={18}
                                            center
                                            style={{
                                                alignSelf: 'center',
                                                paddingHorizontal: 10,
                                                borderRadius: 10,
                                                borderWidth: 1,
                                                borderColor: '#FFFFFF',
                                            }}
                                            onPress={handlePress}
                                        >
                                            <SText font='AlbertSans' bold color={'#FFFFFF'} fontSize={9}>{uploadRetryLabel}</SText>
                                        </SView>
                                        <SView
                                            height={18}
                                            center
                                            style={{
                                                alignSelf: 'center',
                                                paddingHorizontal: 10,
                                                borderRadius: 10,
                                                borderWidth: 1,
                                                borderColor: '#FFFFFF',
                                                backgroundColor: 'rgba(255,255,255,0.08)',
                                            }}
                                            onPress={handleRemovePhoto}
                                        >
                                            <SText font='AlbertSans' bold color={'#FFFFFF'} fontSize={9}>Eliminar</SText>
                                        </SView>
                                    </SView>
                                ) : null}
                            </SView>
                        ) : null}
                    </>
                    ) : (
                        <>
                            <Plus_insert_foto width={35} height={35} />
                            <SHr height={4} />
                            <SView col={"xs-10"} center>
                                <SText font='AlbertSans' bold color={STheme.color.text} fontSize={14} center>{text}</SText>
                            </SView>
                        </>
                    )}
                </SView>
                {Platform.OS === 'web' ? (
                    <input
                        ref={webFileInputRef}
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={handleWebFileChange}
                    />
                ) : null}
            </SView>
            {/* {showPicker ? (
                <SView col="xs-12" style={{ position: 'absolute', top: 0, left: 0, right: 0, width:200, height:300, borderRadius:8, overflow:"hidden", bottom: 0, backgroundColor: 'rgba(3, 10, 24, 0.65)', zIndex: 9998, justifyContent: 'flex-end' }}>
                    <SView col="xs-12" flex onPress={() => setShowPicker(false)} />
                    
                    </SView>
                </SView>
            ) : null} */}
        </>
    );
}